export default "__VITE_PUBLIC_ASSET__26a6d10c__"